import { render } from "./exclamation.vue?vue&type=template&id=2e968396&ts=true"
import script from "./exclamation.ts?vue&type=script&lang=ts"
export * from "./exclamation.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__